<template>
  <layout>
    <div slot="content">
      <i-card title="平台公告">
        <div slot="content">
          <el-collapse accordion>
            <el-collapse-item title="欢迎来到中旅策管理平台" name="1">
              <div>你可以操作中旅策旅游平台的各种数据</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>

export default {
  name: "index",
}
</script>

<style scoped lang="less">
.ee {
  color: @main-color;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue